import { Controller } from 'react-hook-form';
import { format, parseISO } from 'date-fns';
import { useEffect } from 'react';
import { FlowStepPropsWithFormControls } from '../../../types/addFlow.types';
import { DateTimePicker } from '../../DateTimePicker/DateTimePicker';
import { StanTimezoneSelector } from '@/components';
import { DATE_FORMATS } from '@/lib';

export const DateTimeStep = ({ control, errors, setValue, watch, trigger }: FlowStepPropsWithFormControls) => {
    const selectedDate = watch('selectedDate');
    const selectedTime = watch('selectedTime');

    // Re-validate when date or time changes to clear errors immediately
    useEffect(() => {
        if (selectedDate && selectedTime !== undefined) {
            trigger(['selectedDate', 'selectedTime']);
        }
    }, [selectedDate, selectedTime, trigger]);

    // Check if there are any date/time related errors
    const hasDateError = !!errors.selectedDate;
    const hasTimeError = !!errors.selectedTime;
    const errorMessage = errors.selectedDate?.message || errors.selectedTime?.message;

    return (
        <div className='mb-6 flex w-full flex-col gap-4 sm:gap-6'>
            <div className='flex flex-col gap-1'>
                <label className='text-caption-1-regular'>Send on a specific date</label>
                <h3>Select date and time</h3>
            </div>

            <div className='space-y-2'>
                <Controller
                    name='selectedTimezone'
                    control={control}
                    render={({ field }) => (
                        <div>
                            <label htmlFor='timezone-selector' className='text-label-xs-bold'>
                                Timezone
                            </label>
                            <StanTimezoneSelector
                                selectedTimezone={field.value || Intl.DateTimeFormat().resolvedOptions().timeZone}
                                onTimezoneChange={field.onChange}
                            />
                        </div>
                    )}
                />

                <DateTimePicker
                    selectedDate={selectedDate ? parseISO(selectedDate) : undefined}
                    selectedTime={selectedTime ?? 0}
                    onDateChange={date => setValue('selectedDate', date ? format(date, DATE_FORMATS.ISO_8601) : '')}
                    onTimeChange={time => setValue('selectedTime', time)}
                    minDate={new Date()}
                    error={hasDateError || hasTimeError}
                    errorMessage={errorMessage}
                />
            </div>
        </div>
    );
};
